import React, { useState, useEffect } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { t } from 'translation'
import { connect } from 'react-redux'

import BgLoginImg from 'assets/woman.jpg'
import LogoLoginImg from 'assets/logo_tr.png'

const ENV = process.env.NODE_ENV

const ADMIN_URL =
  ENV === 'production'
    ? process.env.ADMIN_URL_PRODUCTION
    : ENV === 'dev-remote'
    ? process.env.ADMIN_URL_DEV_REMOTE
    : process.env.ADMIN_URL_DEVELOPMENT

const LicensePage = (props) => {
  const [scaleClassIsSet, setScaleClassIsSet] = useState(false)

  useEffect(() => {
    document.documentElement.classList.add('no_scale_mod')
    setScaleClassIsSet(true)
    return
  }, [])

  return (
    <section className="section login_mod">
      {!props.location.error ? <Redirect to={'/login'} /> : null}
      {scaleClassIsSet && (
        <>
          <div className="section_bg login_mod">
            <img className="section_bg_img" src={BgLoginImg} alt="section background" />
          </div>
          <div className="section_in login_mod">
            <div className="logo login_mod">
              <img className="logo_img" src={LogoLoginImg} alt="logo" />
            </div>
            <div className="auth_block">
              <h1 className="section_title v4_mod color_mod offset_v4_mod decor_mod center_mod">
                {t('license.SCREEN_LIMIT')}
              </h1>
              <div className="auth_block_descr decor_mod offset_mod center_lvl_mod">
                <p>{t('license.DESCRIPTION_1')}</p>
                <p>{t('license.DESCRIPTION_2')}</p>
                <p>
                  {t('license.DESCRIPTION_3')}
                  <a href={ADMIN_URL} target="_blank" rel="noreferrer noopener">
                    <b>{t('license.DESCRIPTION_LINK')}</b>
                  </a>
                </p>
              </div>
              <div className="phone_system_buttons offset_mod">
                <a
                  className="phone_system_buttons_item btn_download"
                  href={t('license.MORE_LICENSES_EMAIL')}
                  rel="noreferrer noopener"
                >
                  {t('license.MORE_LICENSES')}
                </a>
                <a
                  className="phone_system_buttons_item btn_download"
                  href={t('license.CONTACT_EMAIL')}
                  rel="noreferrer noopener"
                >
                  {t('license.CONTACT')}
                </a>
              </div>
              <div className="btn_wrap center_lvl_mod">
                <Link className="btn_link" to="/login">
                  {t('license.GO_BACK')}
                </Link>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  )
}

const mapStateToProps = ({ auth: { attributes } }) => ({
  alwaysOnWelcomeVideo: attributes?.permissions?.features?.alwaysOnWelcomeVideo,
})

export default connect(mapStateToProps)(LicensePage)
